
EMRAdmin.factory('CommonOC_LazyLoadFactory', ['$ocLazyLoad',
    function ($ocLazyLoad) {
        return {
            ocLazyLoadJsFiles:(fileList)=>{
                    fileList = changeBaseUrlForfilePaths(fileList);
                    return $ocLazyLoad.load({serie: true,
                        files: fileList || []
                    });
            }
        };
    }]);

